import { FC, ReactNode } from 'react'
import cn from 'classnames'

interface LabelValueProps {
  children: ReactNode
  label: string
  className?: string
  ddClassName?: string
  labelClassName?: string
}

export const LabelValue: FC<LabelValueProps> = ({ label, children, ddClassName, className, labelClassName }) => (
  <dl className={cn('flex flex-col items-center gap-1', className)}>
    <dt className={cn('text-ticket-caption', labelClassName ?? 'text-neutral-darker')}>{label}</dt>
    <dd className={ddClassName}>{children}</dd>
  </dl>
)
